import React, { useEffect, useState } from "react";
import { getNumber } from "@/helpers/validation";
import TrialFooter, { BundleItem } from "./BundleTrialFooter";
import { setCartAndCheckout } from "@/services/shopifyCart";

export interface TrialHeaderProps {
  shopViewLink: string;
  maxNumItems: number;
}

export default function BundleTrialFooter({
  shopViewLink,
  maxNumItems,
}: TrialHeaderProps) {
  const [items, setItems] = useState<BundleItem[]>([]);
  useEffect(() => {
    if (!window.trialBundle) {
      window.trialBundle = {};
    }

    window.trialBundle.addItem = (item: unknown) => {
      if (items.length >= 2) {
        return;
      }
      if (
        item &&
        typeof item === "object" &&
        typeof (item as any).image === "string" &&
        typeof (item as any).title === "string" &&
        typeof (item as any).id === "number" &&
        typeof (item as any).pageLink === "string" &&
        typeof (item as any).quantity === "number"
      ) {
        const bundleItem = item as BundleItem;
        if (items.find((x) => x.id === bundleItem.id)) {
          return;
        }
        setItems([...items, bundleItem]);
      }
    };

    window.trialBundle.removeItem = (itemId: unknown) => {
      const numId = getNumber(itemId);
      const remainder = items.filter((x) => x.id !== numId);
      setItems(remainder);
    };

    window.trialBundle.items = () => {
      return [...items];
    };
  }, [items]);

  const handleClick = () => {
    if (items.length == 0) {
      location.href = shopViewLink;
    } else {
      setCartAndCheckout(
        items.map((x) => ({
          id: x.id,
          quantity: x.quantity,
        })),
        "bundles_trial"
      );
    }
  };

  return (
    <TrialFooter
      numItems={maxNumItems}
      handleClick={handleClick}
      items={items}
      viewProductsLink={shopViewLink}
    />
  );
}
